module.exports = __webpack_public_path__ + "img/document-text.55dd0b3e.svg";